// The single generation-id factory shared by every surface that starts an AI
// weekly plan generation. Promoted verbatim out of `useOnboardingGeneration`
// in Phase 10B so the AI Weekly Plan Builder reuses onboarding's format and
// fallback instead of introducing a second random-id algorithm.
export function createGenerationId() {
  if (typeof window !== "undefined" && typeof window.crypto?.randomUUID === "function") {
    return window.crypto.randomUUID();
  }
  return `generation_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

export default createGenerationId;
